import axios from "axios"
var Config = require('../config.json')
import AuthService from '../service/auth'

class BaseService {
	
	constructor(entity) {
		this.entity=entity;
	}
	/*
	//test
	test(){
		return {'entity':this.entity};
	}
	//public
	getPublic() {
		return axios.get(Config.api_url+'/public/'+this.entity);
    }*/
	//test function
	test() {
		return {'message':'base function'};
	}
	
	//CRUD functions
    create(obj) {
	var bearerToken =AuthService.getBearerToken();
		const header = {
			headers: { Authorization: 'Bearer '+bearerToken }
		};
		return axios.post(Config.api_url+'/'+this.entity,obj,header);
    } 
    getAll() {
		var bearerToken =AuthService.getBearerToken();
		const header = {
			headers: { Authorization: 'Bearer '+bearerToken }
		};
		return axios.get(Config.api_url+'/'+this.entity,header);
    }
    getById(id) {
		var bearerToken =AuthService.getBearerToken();
		const header = {
			headers: { Authorization: 'Bearer '+bearerToken }
		};
		return axios.get(Config.api_url+'/'+this.entity+'/'+id,header);
    }
    getByFilter(filter) {
		var bearerToken =AuthService.getBearerToken();
		const header = {
			headers: { Authorization: 'Bearer '+bearerToken }
		};
		var qs = serialize(filter);
		return axios.get(Config.api_url+'/'+this.entity+'/filter/params?'+qs,header);
    }
    update(request) {
		var bearerToken =AuthService.getBearerToken();
		const header = {
			headers: { Authorization: 'Bearer '+bearerToken }
		};
		return axios.put(Config.api_url+'/'+this.entity+'/'+request._id,request,header);
    }
    deleteById(id) {
		var bearerToken =AuthService.getBearerToken();
		const header = {
			headers: { Authorization: 'Bearer '+bearerToken }
		};
		return axios.delete(Config.api_url+'/'+this.entity+'/'+id,header);
    }
};

function serialize(obj) {
	var str = [];
	for (var p in obj)
	if (obj.hasOwnProperty(p)) {
		str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	}
	return str.join("&");
}
		
export default BaseService;